import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SubordinateCollectionReport } from './Pages';

export const SubordinateCollectionReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={SubordinateCollectionReport} />
    </Fragment>
)